export const name = 'ComposerController';
export default function ComposerController($log, ecommerceFactory, privilegesService, $q, breadcrumbsService, templatesService, sdkManagementService, errorDialogOpen, $translate) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  var vm = this;
  vm.isEcommerceInitialized = false;

  //TODO: eventually we will get this list from the backend, hard coded here as temporary solution....
  vm.navItemsArr = [
    {
      id: 'templates',
      loc: {
        name: 'imposer.composer-main.Templates'
      },
      icon: {
        type: 'svg',
        name: 'composer/images/composition_template.svg'
      },
      state: 'templates'
    },
    {
      id: 'pdflist',
      loc: {
        name: 'imposer.composer-main.Composed_Pdfs'
      },
      icon: {
        type: 'svg',
        name: 'composer/images/pdf_icon.svg'
      },
      state: 'pdflist'
    },
    {
      id: 'assets-management',
      loc: {
        name: 'imposer.composer-main.assets_management'
      },
      icon: {
        type: 'svg',
        name: 'composer/images/assets_management.svg'
      },
      state: 'assets-management'
    },
    {
      id: 'presets',
      loc: {
        name: 'imposer.composer-main.presets'
      },
      icon: {
        type: 'svg',
        name: 'composer/images/presets.svg'
      },
      state: 'presets'
    }//,
    // {
    //   id: 'quota',
    //   loc: {
    //     name: 'imposer.composer-main.records_quota_lower'
    //   },
    //   icon: {
    //     type: 'svg',
    //     name: 'composer/images/records_quota.svg'
    //   },
    //   state: 'quota'
    // }
  ];

  vm.navItems = ()=> {
    let defer = $q.defer();
    let promises = [];

    promises.push(isSdkInUse());
    promises.push(isAdminPermissionExist());
    $q.all(promises).then(
      function(){
          promises[0].then(function(isSdkInUse){
            promises[1].then(function(isAdminPermissionExist){
              if(isAdminPermissionExist){
                vm.navItemsArr.push({
                  id: 'administration',
                  loc: {
                    name: 'imposer.composer-main.administration'
                  },
                  icon: {
                    type: 'svg',
                    name: 'composer/images/supervisor_account.svg'
                  },
                  state: 'administration'
                });
              }
              if(isSdkInUse){
                vm.navItemsArr.push({
                  id: 'sdk-management',
                  loc: {
                    name: 'imposer.composer-main.sdk_management'
                  },
                  icon: {
                    type: 'svg',
                    name: 'composer/images/sdk.svg'
                  },
                  state: 'sdk-management'
                });
              }
              defer.resolve(vm.navItemsArr);
            },function(){defer.reject();});
          },function(){defer.reject();});
      },function(){
        defer.reject();
      }
    );

    return defer.promise;
  };

/*  function isEcommerceEnabled(){
    return ecommerceFactory.getEcommerceData().then(ecommerceInfo => {
      return ecommerceInfo.ecommerceEnabled;
    });
  }*/

  function isSdkInUse() {
    return sdkManagementService.isSdkInUse().then(response => {
      return response.data.skdInUse;
    });
  }

  function isAdminPermissionExist() {
    return privilegesService.getPrivileges().then(privileges => {
      if(!privileges.permissions){
        return false;
      }
      let isAdminPermissionExist = privileges.permissions.filter(curr => curr === 'eCommerce Refund');
      return isAdminPermissionExist.length > 0;
    });
  }

  let templatesBreadcrumb = [{
    id: 'templates',
    display: 'Template_Imposition_Templates',
  }];

  let templateDetailsBreadcrumb = templatesBreadcrumb.concat(
    [{
      id: 'templates.templatedetails',
      display: 'Template_Imposition_Template'
    }]);

  let templateDetailsWithDataBreadcrumb = templatesBreadcrumb.concat(
    [{
      id: 'templates.templatedetailswithdata',
      display: 'Template_Imposition_Template'
    }]);

  let breadcrumbs = {
    'templates': templatesBreadcrumb,
    'pdflist': [
      {
        id: 'pdflist',
        display: 'Composer_PDF_List'
      }
    ],
    'quota':[
      {
        id: 'quota',
        display: 'records_quota_lower'
      }
    ],
    'assets-management':[
      {
        id: 'assets-management',
        display: 'assets_management'
      }
    ],
    'sdk-management':[
      {
        id: 'skd-management',
        display: 'sdk_management'
      }
    ],
    'administration':[
      {
        id: 'administration',
        display: 'administration'
      }
    ],
    'presets':[
      {
        id: 'presets',
        display: 'presets'
      }
    ],
    'presets.presetdetails':[
      {
        id: 'presets',
        display: 'presets'
      },
      {
        id: 'presets.presetdetails',
        display: 'preset_details'
      }
    ],
    'presets.presetdetails.imposition':[
      {
        id: 'presets',
        display: 'presets'
      },
      {
        id: 'presets.presetdetails',
        display: 'preset_details'
      },
      {
        id: 'presets.presetdetails.imposition',
        display: 'Imposition_Template'
      }
    ],
    'templates.templatedetails': templatesBreadcrumb.concat(
      [{
        id: 'templates.templatedetails',
        display: 'Template_Imposition_Template'
      }]),
    'templates.templatedetails.imposedpreview': templateDetailsBreadcrumb.concat([
      {
        id: 'templates.templatedetails.imposedpreview',
        display: 'imposed_preview'
      }
    ]),
    'templates.templatedetails.pagepreview': templateDetailsBreadcrumb.concat([
      {
        id: 'templates.templatedetails.pagepreview',
        display: 'imposed_preview'
      }
    ]),
    'templates.templatedetails.imposition': templateDetailsBreadcrumb.concat([
      {
        id: 'templates.templatedetails.imposition',
        display: 'Imposition_Template'
      }
    ]),
    'templates.templatedetails.imposition.zoomin': templateDetailsBreadcrumb.concat([
      {
        id: 'templates.templatedetails.imposition.zoomin',
        display: 'Template_Zoom_In'
      }
    ]),
    'templates.templatedetails.fulldataview': templateDetailsBreadcrumb.concat([
      {
        id: 'templates.templatedetails.fulldataview',
        display: 'Template_Database'
      }
    ]),
    'templates.templatedetailswithdata': templateDetailsWithDataBreadcrumb,
    'templates.templatedetailswithdata.imposedpreview': templateDetailsWithDataBreadcrumb.concat([
      {
        id: 'templates.templatedetails.imposedpreview',
        display: 'imposed_preview'
      }
    ]),
    'templates.templatedetailswithdata.pagepreview': templateDetailsWithDataBreadcrumb.concat([
      {
        id: 'templates.templatedetails.pagepreview',
        display: 'imposed_preview'
      }
    ]),
    'templates.templatedetailswithdata.imposition': templateDetailsWithDataBreadcrumb.concat([
      {
        id: 'templates.templatedetails.imposition',
        display: 'Imposition_Template'
      }
    ]),
    'templates.templatedetailswithdata.imposition.zoomin' : templateDetailsWithDataBreadcrumb.concat([
        {
          id: 'templates.templatedetails.imposition.zoomin',
          display: 'Template_Zoom_In'
        }
      ])
  };

  breadcrumbsService.initBreadcrumbs(breadcrumbs);

  //Check if HP inc. organization
  templatesService.getConfigurations().then(response => {
    if(response.context.name === 'HP Inc.'){
      //launch warning dialog
      $translate.onReady(function() {
        let errorMassage = $translate.instant('imposer.composer-main.hp_inc_composer_error_message');
        let errorInfo = {
          smsError: {
            httpStatusCode: 406, subCode: -1, message: errorMassage
          }
        };
        errorDialogOpen.openErrorDialog(errorInfo);
      });
    }
  });
}
